var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1067_267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 21.1293C0 11.1732 0 6.19518 3.09295 3.10223C6.1859 0.00927734 11.1639 0.00927734 21.12 0.00927734H22.88C32.8361 0.00927734 37.8141 0.00927734 40.9071 3.10223C44 6.19518 44 11.1732 44 21.1293V22.8893C44 32.8454 44 37.8233 40.9071 40.9164C37.8141 44.0093 32.8361 44.0093 22.88 44.0093H21.12C11.1639 44.0093 6.1859 44.0093 3.09295 40.9164C0 37.8233 0 32.8454 0 22.8893V21.1293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4117 31.7076C13.3833 31.7076 7.66343 24.8326 7.42509 13.3926H12.4484C12.6134 21.7892 16.3167 25.3459 19.25 26.0792V13.3926H23.9802V20.6342C26.8769 20.3226 29.9198 17.0226 30.9465 13.3926H35.6766C34.8882 17.8659 31.5882 21.1659 29.2416 22.5226C31.5882 23.6226 35.3468 26.5009 36.7768 31.7076H31.5699C30.4516 28.2242 27.6652 25.5292 23.9802 25.1626V31.7076H23.4117Z",
    fill: "#334E5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1067_267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0 0.00927734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.8cff51e1dde01f842751a1d7e95f8c51.svg";
export { ForwardRef as ReactComponent };